import { POWER_ORIGINALS_LABEL } from "@/domain/casino/ai-images/card-label"

export const homePageTexts = {
  title: "Pronósticos Deportivos y Casino en Powerbet",
  description:
    "Disfruta de las mejores pronosticos deportivas y juegos de casino en línea en Powerbet. Regístrate hoy y recibe bonos exclusivos para maximizar tus ganancias."
} as const

export const promoTexts = {
  ariaLabel: "Banners de promociones",
  dotLabel: "Ir al banner",
  preTitle: "Conocer",
  title: "RAYO",
  description: "nuestra nueva mascota",
  buttonText: "¡SALUDAR!"
} as const

export const quickLinksTexts = {
  ariaLabel: "Accesos rápidos",
  play: "Jugar",
  casino: {
    title: "Casino",
    description: "Miles de juegos y grandes premios Entrar al Casino"
  },
  sports: {
    title: "Deportes",
    description: "Apuestas en vivo y prepartido Ir a Deportes"
  }
} as const

export const statsCarouselTexts = {
  ariaLabel: "Estadísticas",
  playersRegistered: "Jugadores Registrados",
  paidAmount: "Monto pagado esta semana",
  rating: "Calificación"
} as const

export const vipBannerTexts = {
  ariaLabel: "Banner del programa VIP",
  title: "ÚNETE AL PROGRAMA VIP",
  description: "Accede a beneficios exclusivos y sube de nivel",
  button: "CONOCER MÁS"
} as const

export const verificationBannerTexts = {
  ariaLabel: "Banner de verificación",
  kyc: {
    title: "Verifica tu cuenta y recibe",
    reward: "L 50",
    description:
      "Completa tu verificación en Metamap y accede a beneficios exclusivos.",
    button: "VERIFICAR AHORA",
    hint: "Toma menos de 2 minutos"
  },
  firstDeposit: {
    title: "Haz tu primer depósito para activar tu Bono Primer Deposito 300%",
    button: "Deposita ya"
  },
  email: {
    title: "Verifica tu correo",
    button: "Verificar ahora",
    sentTitle: "Correo enviado",
    sentDescription: "Revisa tu bandeja de entrada para verificar tu correo.",
    errorTitle: "No se pudo enviar el correo",
    errorDescription: "Inténtalo de nuevo en unos momentos.",
    limitTitle: "Ya te enviamos el correo",
    limitDescription:
      "Alcanzaste el límite de envíos. Revisa tu bandeja o inténtalo más tarde."
  },
  withdrawals: {
    title: "Sabías que Powerbet tiene los retiros más rápidos de {country}.",
    fallbackCountry: "tu país"
  }
} as const

export const searchTexts = {
  ariaLabel: "Buscar",
  placeholder: "Buscar",
  clear: "Borrar búsqueda"
} as const

export const categoryPreviewTexts = {
  origami: POWER_ORIGINALS_LABEL,
  cards: "Cartas",
  roulette: "Ruleta",
  live: "En vivo"
} as const
